import React, { Component, Fragment } from "react"
import getFirebase, { FirebaseContext } from "./Firebase"
import withAuthentication from "./Session/withAuthentication"
import { AuthUserContext } from "./Session"
import Navbar from "./Layouts/NavBar"
import Footer from "./Layouts/Footer"
import Seo from "./seo"
import { Helmet } from "react-helmet"

class Layout extends Component {
  state = {
    firebase: null,
  }

  componentDidMount() {
    const app = import("firebase/app")
    const auth = import("firebase/auth")
    const database = import("firebase/database")

    Promise.all([app, auth, database]).then((values) => {
      const firebase = getFirebase(values[0])

      this.setState({ firebase })
    })
  }

  render() {
    return (
      <FirebaseContext.Provider value={this.state.firebase}>
        <AppWithAuthentication {...this.props} />
      </FirebaseContext.Provider>
    )
  }
}

const AppWithAuthentication = withAuthentication((props) => (
  <Fragment>
    <Helmet>
      <script
        src="//assets.adobedtm.com/175f7caa2b90/8b8d5b2083f7/launch-9fdd57db37ca.min.js"
        async
      ></script>
      <script src="//fw-cdn.com/2540554/3066085.js" chat="false"></script>
    </Helmet>
    <Seo
      title={props.title}
      description={props.description}
      image={props.image}
    />
    <AuthUserContext.Consumer>
      {(authUser) => <Navbar loggedIn={!!authUser} />}
    </AuthUserContext.Consumer>
    <div className="page-contain">{props.children}</div>
    <Footer />
  </Fragment>
))

export default Layout
